import { Checkbox } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import BreadcrumbsComponent from "../../../Components/BreadCrumbs";
import CustomButton from "../../../Components/CustomButton";
import LeftSideNav from "../../../Components/LeftSideNav";
import TopNavBar from "../../../Components/TopNavbar";
import Fonts from "../../../Config/Fonts";
import Strings from "../../../Config/Strings";
import { rolePermissionTableHeader } from "../../../Constants/MockData";
import {
  addRolePermissionAPI,
  deleteRolePermissionAPI,
  getAllModulesAPI,
  getRolePermissionByIdAPI,
  updateRolePermissionAPI,
} from "../../../Store/Action/rolePermissionAction";
import { deleteUserRolePermissionAPI } from "../../../Store/Action/userRolePermissionAction";
import Colors from "../../../theme/Colors";

const getCheckboxValue = (moduleIndex, checkboxIndex) => {
  return moduleIndex * 4 + checkboxIndex + 1; // Example calculation for checkbox ID
};

const RolePermissionModuleList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { roles } = location?.state || {};

  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const [selectedCheckboxes, setSelectedCheckboxes] = useState(new Set());
  const [roleModuleName, setRoleModuleName] = useState([]);
  const [isEdit, setIsEdit] = useState(false);

  useEffect(() => {
    setBreadcrumbs([
      { key: "1", href: "/", text: "Master" },
      { key: "2", href: "/masters", text: "Role Permission" },
      { key: "2", href: "/masters", text: "Update" },
    ]);

    dispatch(
      getRolePermissionByIdAPI(roles?.user_role_id, (result) => {
        const permissionIds = result?.flatMap((item) => item?.permission_id);
        if (permissionIds && permissionIds.length > 0) {
          setIsEdit(true);
        } else if (permissionIds?.length === 0) {
          dispatch(
            deleteUserRolePermissionAPI(
              result?.role_permission_id,
              (isSuccess, response) => {
                if (isSuccess?.status === true) {
                  toast.success(response?.data);
                  navigate("/rolePermissionList");
                } else {
                  const errorMessage =
                    response?.error || Strings.somethingWentWrongError;
                  toast.error(errorMessage);
                }
              }
            )
          );
        }
        setSelectedCheckboxes(new Set(permissionIds));
      })
    );

    dispatch(
      getAllModulesAPI({}, (result) => {
        setRoleModuleName(result?.data);
      })
    );
  }, [dispatch, navigate, roles?.user_role_id]);

  const handleCheckboxChange = (event, moduleIndex, roleIndex) => {
    const isChecked = event.target.checked;
    const simpleId = getCheckboxValue(moduleIndex, roleIndex);
    setSelectedCheckboxes((prev) => {
      const newSelectedCheckboxes = new Set(prev);
      if (isChecked) {
        newSelectedCheckboxes.add(simpleId);
      } else {
        newSelectedCheckboxes.delete(simpleId);
      }
      return newSelectedCheckboxes;
    });
  };

  const onAddRolePermission = async () => {
    const addRolePermissionRequestData = {
      role_id: roles?.user_role_id,
      permission_id: Array.from(selectedCheckboxes),
    };
    const rolePermissionApiCall = isEdit
      ? updateRolePermissionAPI
      : addRolePermissionAPI;
    if (selectedCheckboxes?.size === 0) {
      try {
        await dispatch(
          deleteRolePermissionAPI(
            roles?.user_role_id,
            (isSuccess, response) => {
              if (isSuccess?.status === true) {
                toast.success(response?.data);
                navigate("/userRolePermissionList");
              } else {
                const errorMessage =
                  response?.error || Strings.somethingWentWrongError;
                toast.error(errorMessage);
              }
            }
          )
        );
      } catch (error) {
        console.log("Error dispatching deleteUserRolePermissionAPI:", error);
        toast.error(Strings.somethingWentWrongError);
      }
    } else {
      try {
        await dispatch(
          rolePermissionApiCall(
            addRolePermissionRequestData,
            (isSuccess, response) => {
              if (isSuccess?.status === true) {
                toast.success(response?.data);
                navigate("/rolePermissionList");
              } else {
                const errorMessage =
                  response?.error?.message || Strings.somethingWentWrongError;
                toast.error(errorMessage);
              }
            }
          )
        );
      } catch (error) {
        console.log("Error dispatching addRolePermissionAPI:", error);
        toast.error(Strings.somethingWentWrongError);
      }
    }
  };

  return (
    <div style={mainContainerStyle}>
      <LeftSideNav />
      <div style={topContainerStyle}>
        <TopNavBar leftSideText={"Role Permission"} />
        <BreadcrumbsComponent breadcrumbs={breadcrumbs} />
        <div style={tableContainerStyle}>
          <div style={outerWrapper}>
            <div
              style={{
                textAlign: "center",
                backgroundColor: Colors.adminPrimaryColor,
                width: "100%",
                color: Colors.white,
                borderTopLeftRadius: "20px",
                borderTopRightRadius: "20px",
                padding: "8px 8px",
              }}
            >
              Permissions
            </div>
            <div style={tableWrapper}>
              <table style={table}>
                <thead style={{borderBottom: '1px solid #e6e6e6'}}>
                  <th style={tableLabelText}>
                    Module Name
                  </th>
                  {rolePermissionTableHeader?.map((tCell, index) => (
                    <th key={index} style={tableLabelText}>
                      {tCell?.header}
                    </th>
                  ))}
                </thead>
                <tbody>
                  {roleModuleName?.map((module, moduleIndex) => (
                    <tr key={moduleIndex}>
                      <td style={tableInputTxtStyle}>{module?.module_name}</td>
                      {rolePermissionTableHeader?.map((_, roleIndex) => {
                        const simpleId = getCheckboxValue(
                          moduleIndex,
                          roleIndex
                        );
                        return (
                          <td key={simpleId} style={{borderBottom: "1px solid #E6E6E6",}}>
                            <Checkbox
                              size="medium"
                              id={simpleId}
                              checked={selectedCheckboxes.has(simpleId)}
                              onChange={(event) =>
                                handleCheckboxChange(
                                  event,
                                  moduleIndex,
                                  roleIndex
                                )
                              }
                              sx={{
                                // Unchecked state
                                "& .MuiSvgIcon-root": {
                                  color: "#363740", // Set the icon color when unchecked
                                  borderRadius: "2px", // Optional: border-radius for rounded corners
                              
                                },
                                // Checked state
                                "&.Mui-checked .MuiSvgIcon-root": {
                                  color: "#363740", // Change the icon color when checked
                        
                                },
                              }}
                            />
                          </td>
                        );
                      })}
                    </tr>
                  ))}
                </tbody>
              </table>

            <div style={{marginTop: '15px'}}>
            <CustomButton
                label={Strings.Save}
                handleSubmit={onAddRolePermission}
              />
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Styling objects (adapt as needed)
const mainContainerStyle = {
  display: "grid",
  gridTemplateColumns: "20% 85%",
  height: "100vh",
  width: "100vw",
  overflow: "hidden", // Hide all overflow
};

const topContainerStyle = {
  backgroundColor: Colors.bgColor,
  display: "flex",
  flexDirection: "column",
  height: "100%",
  width: "94%",
};

const tableContainerStyle = {
  backgroundColor: "white",
  paddingTop: "20px",
  width: "96%",
  marginTop: "15px",
  marginLeft: "20px",
  height: "80%",
};

const outerWrapper = {
  borderRadius: "12px",
  height: "100%",
  width: "55%",
  backgroundColor: Colors.white,
  marginLeft: "30px",
  borderTopLeftRadius: "20px",
  borderTopRightRadius: "20px",
};

const tableWrapper = {
  overflowY: "hidden",
  overflowX: "hidden",
  height: "96%",
};

const table = {
  minWidth: "100%",
  borderCollapse: "separate",
  borderSpacing: "0px",
  border: "1px solid #ccc",
  borderBottomLeftRadius: "20px",
  borderBottomRightRadius: "20px",
};

const tableLabelText = {
  fontSize: 12,
  fontWeight: "500",
  fontFamily: Fonts.Poppins,
  color: Colors.breadCrumbsColor,
  position: "sticky",
  top: 0,
  padding: '10px 10px',
  textAlign: "center",
  borderRight: 'none',
  borderBottom: "1px solid #E6E6E6",
};

const tableInputTxtStyle = {
  fontSize: 12,
  fontWeight: "500",
  fontFamily: Fonts.Poppins,
  color: Colors.black,
  borderBottom: "1px solid #E6E6E6",
};

export default RolePermissionModuleList;
